import { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';

import { guaranteeReturnsServices } from '@services';
import { getCleanedUrlParams, showError } from '@utils';

import { QUERY_KEYS } from 'constants/queryKeys';
import { GUARANTEE_RETURNS_PAGE_SIZE } from './constants';

const useGuaranteeReturnsOperations = () => {
  const { query, isReady } = useRouter();

  const { page = 1, pageSize = GUARANTEE_RETURNS_PAGE_SIZE } = query;

  const pageSizeCalculated = useMemo(
    () => parseInt(pageSize, 10) || GUARANTEE_RETURNS_PAGE_SIZE,
    [pageSize]
  );

  const cleanedParams = getCleanedUrlParams({
    page,
    pageSize: pageSizeCalculated,
    origin,
  });

  const {
    data: guaranteeReturnsData,
    isLoading: isGuaranteeReturnsLoading,
    error: guaranteeReturnsError,
    refetch: guaranteeReturnsRefetch,
  } = useQuery(
    [QUERY_KEYS.GET_GUARANTEE_RETURNS_KEY, cleanedParams],
    () => guaranteeReturnsServices.getGuaranteeReturns(cleanedParams),
    { enabled: isReady }
  );

  const error = useMemo(() => guaranteeReturnsError, [guaranteeReturnsError]);

  useEffect(() => {
    if (error) {
      showError(error);
    }
  }, [error]);

  return {
    page,
    total: guaranteeReturnsData?.meta?.total,
    pageSize: pageSizeCalculated,
    loading: isGuaranteeReturnsLoading,
    data: guaranteeReturnsData?.data || [],
    getGuaranteeReturnsData: guaranteeReturnsRefetch,
  };
};

export default useGuaranteeReturnsOperations;
